// Brand copy for the admin app's auth screens — one source so login,
// register and forgot-password never drift apart. Feature `icon` values are
// keys into AuthLayout's stroke-icon set, so this file stays plain data.
export const ADMIN_BRAND = {
  brandIcon: 'PS',
  brandTitle: 'Practice Suite',
  brandTagline: 'Run your entire practice from one place.',
  brandAccent:
    'Clients, statutory deadlines, task approvals and billing — the operating system for an Indian CA firm.',
  features: [
    {
      icon: 'calendar',
      title: 'Compliance calendar',
      desc: 'GST, TDS, ITR & ROC deadlines tracked per client, per period.',
    },
    {
      icon: 'approve',
      title: 'Approval-driven task flows',
      desc: 'Auto-proposed filings, manager sign-off, preparer and reviewer roles.',
    },
    {
      icon: 'chart',
      title: 'Clients, billing & reports',
      desc: 'Portfolios, fee & OPE billing, workload and performance analytics.',
    },
    {
      icon: 'shield',
      title: 'Bank-grade sessions',
      desc: 'Rotating three-token sessions, role-based access, full audit trail.',
    },
  ],
  stats: [
    { value: '18+', label: 'Statutory heads' },
    { value: 'Multi-firm', label: 'True multi-tenant' },
    { value: 'RBAC', label: 'Role-based access' },
  ],
};
